import { render, staticRenderFns } from "./FormTool.vue?vue&type=template&id=45a978be&"
import script from "./FormTool.vue?vue&type=script&lang=js&"
export * from "./FormTool.vue?vue&type=script&lang=js&"
import style0 from "./FormTool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports